import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getFilmOtt } from './get-film-ott';

export function getFilmWatchParams(
    filmOrVideo:
        | LegacyFilmPlayerBaseInfoContent
        | LegacyVideoPlayerBaseInfoContent
        | undefined
        | null
) {
    const ott = filmOrVideo && getFilmOtt(filmOrVideo);

    return ott?.userData?.watchParams || undefined;
}
